import { Button } from 'antd';
import apiCall from 'apps/futureflex/apiCalls/employee';
import {
  CreatePage,
  DetailPage,
  EditPage,
  ListPage,
} from 'common/ui/AdminCRUD/page';
import { Link } from 'react-router-dom';
import ItemDetail from './Detail';
import FilterForm from './FilterForm';
import ItemForm from './Form';
import { columnsGenerator } from './config';

export const InvestmentEmployeeListPage = (props, { params }) => (
  <ListPage
    enableSearch={true}
    title="All Employees"
    apiCall={apiCall}
    params={params}
    FilterForm={FilterForm}
    createUrl={`/futureflex/employees/create`}
    columnGenerator={props => columnsGenerator(props)}
    resourceName="data"
    {...props}
  />
);

export const InvestmentEmployeeDetailPage = props => (
  <DetailPage
    title="Employee"
    apiCall={apiCall}
    listUrl={`/futureflex/employees`}
    ItemDetail={ItemDetail}
    resourceName="data"
    extraActions={id => (
      <Button type="primary">
        <Link to={`/futureflex/employees/${id}/edit`}>Edit</Link>
      </Button>
    )}
    {...props}
  />
);

export const InvestmentEmployeeEditPage = props => (
  <EditPage
    title="Employee"
    apiCall={apiCall}
    listUrl={`/futureflex/employees`}
    ItemForm={ItemForm}
    resourceName="data"
    options={{
      title: 'Edit Employee',
    }}
    {...props}
  />
);

export const InvestmentEmployeeCreatePage = props => (
  <CreatePage
    title="Employee"
    apiCall={apiCall}
    listUrl={`/futureflex/employees`}
    ItemForm={ItemForm}
    resourceName="data"
    {...props}
  />
);
